import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { paginateQuery } from '@/lib/paginateSupabase';

export interface GeneratedCertificateRow {
  id: string;
  user_id: string;
  user_name: string;
  user_email: string;
  certificate_name: string;
  diploma_type: 'A' | 'B' | null;
  generated_at: string;
  download_count: number;
  organization_id: string | null;
  cohort_id: string | null;
  program_id: string | null;
  program_certificate_id: string | null;
  cohort: { id: string; name: string } | null;
  program: { id: string; name: string } | null;
  organization: { id: string; name: string } | null;
  program_certificate: any | null;
}

export function useGeneratedCertificates(selectedOrg: string) {
  const { currentRole, profile } = useAuth();
  const isSuperAdmin = currentRole === 'super_admin';

  return useQuery({
    queryKey: ['generated-certificates', selectedOrg, isSuperAdmin, profile?.organization_id],
    queryFn: async () => {
      const data = await paginateQuery<any>((from, to) => {
        let q = supabase
          .from('certificate_logs')
          .select(`
            id, user_id, user_name, user_email, certificate_name, diploma_type,
            generated_at, download_count, organization_id, cohort_id, program_id,
            program_certificate_id,
            cohort:cohort_id (id, name),
            program:program_id (id, name),
            organization:organization_id (id, name),
            program_certificate:program_certificate_id (*)
          `)
          .order('generated_at', { ascending: false })
          .range(from, to);

        if (isSuperAdmin) {
          if (selectedOrg === 'public') {
            q = q.is('organization_id', null);
          } else if (selectedOrg && selectedOrg !== 'all') {
            q = q.eq('organization_id', selectedOrg);
          }
        } else if (profile?.organization_id) {
          q = q.eq('organization_id', profile.organization_id);
        }
        return q;
      });
      return data as unknown as GeneratedCertificateRow[];
    },
    enabled: isSuperAdmin || !!profile?.organization_id,
  });
}
